import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import {
  Alert
} from '../api/data-model';
import { BACKEND_URL } from '../app.config';


@Injectable()
export class AlertService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string, private readonly router: Router) { }

  getAlerts(matterId?: string, companyId?: string, foreignNationalId?: string): Observable<ListResult<Alert>> {
    return this.http.get<ListResult<Alert>>(`${this.baseUrl}/api/app/alert`, {
      params: {
        matterId: matterId ?? '',
        companyId: companyId ?? '',
        foreignNationalId: foreignNationalId ?? '',        
      },
    });
  }  
}
